import { render } from "./cardNowMomentComponent.vue?vue&type=template&id=ea97eb70"
import script from "./cardNowMomentComponent.vue?vue&type=script&lang=js"
export * from "./cardNowMomentComponent.vue?vue&type=script&lang=js"

import "./cardNowMomentComponent.vue?vue&type=style&index=0&id=ea97eb70&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__